import axios from '@/utils/blytz-axios'
import endpoints from '@/utils/endpoints'
import { Dict } from '@/utils/interfaces'

export async function resolveLoginDestination(
  next?: string
): Promise<string | { name: string }> {
  const fallback = next || { name: 'AccountsList' }

  // promise-confirmation links always deep-link to their account, even when
  // other accounts also have payments due
  if (next && /[?&]intent=promise(&|$)/.test(next)) {
    return next
  }

  try {
    const res = await axios.get(endpoints.listAccountRoots(), {
      params: { page_size: 100 }
    })
    const dueCount = (res.data?.results || []).filter(
      (acc: Dict) => Number(acc.amount_due) > 0
    ).length

    if (dueCount > 1) {
      return { name: 'AccountsList' }
    }
  } catch {
    return fallback
  }

  return fallback
}
